import {loginApi} from '../api';
import AdminWelcomeEmailActions from 'actions/admin/AdminWelcomeEmailActions';
import {List} from 'immutable';
import WelcomeEmailUser from 'records/admin/WelcomeEmailUser';

const AdminWelcomeEmailSource = {
  fetchUserList: {
    remote(state) {
      return loginApi.get(`/password/new_users`).then(resp => {
        return List(resp.data.users.map(user => new WelcomeEmailUser(user)));
      });
    },
    success: AdminWelcomeEmailActions.fetchUserListSuccess,
    error: AdminWelcomeEmailActions.fetchUserListError,
  },
  sendWelcome: {
    remote(state, userIds) {
      return loginApi.postJson('/password/new_users', {userIds});
    },
    loading: AdminWelcomeEmailActions.sendWelcomeLoading,
    success: AdminWelcomeEmailActions.sendWelcomeSuccess,
    error: AdminWelcomeEmailActions.sendWelcomeError,
  },
};

export default AdminWelcomeEmailSource;
